"use strict";

// Un solo deferred por oleada: al cambiar un filtro se resuelve y Angular aborta
// todos los getDistinctItemFromFormField y myitems en vuelo.

function isGraphDataRequest(url) {
  if (!url) return false;
  return url.indexOf("getDistinctItemFromFormField") !== -1
    || /\/myitems(\?|$)/i.test(url);
}

const factory = ["$q", function ($q) {
  let waveDeferred = $q.defer();

  const newWave = () => {
    waveDeferred = $q.defer();
    return waveDeferred.promise;
  };

  return {
    isGraphDataRequest: isGraphDataRequest,
    timeoutPromise: () => waveDeferred.promise,
    cancelAll: () => {
      waveDeferred.resolve("cancelled");
      newWave();
    }
  };
}];

factory.interceptor = ["graphHttpCancel", function (graphHttpCancel) {
  return {
    request: (config) => {
      if (!graphHttpCancel.isGraphDataRequest(config.url)) {
        return config;
      }
      config.timeout = graphHttpCancel.timeoutPromise();
      return config;
    }
  };
}];

module.exports = factory;
